export default function Footer(){
    return (
        <footer className="bg-green-900 border-t">
        <div className="mx-auto max-w-screen px-4 py-16 sm:px-6">
            <div className="mt-8 border-t border-green-100 pt-8">
            <div className="sm:flex sm:justify-between">
                <p className="text-xs font-Raleway text-white">&copy; {new Date().getFullYear()}. WITS. All rights reserved.</p>

                <ul className="mt-8 flex font-Raleway flex-wrap justify-start gap-4 text-xs sm:mt-0 lg:justify-end">
                <li>
                    <a href="#" className="text-white transition hover:opacity-75"> Terms & Conditions </a>
                </li>

                <li>
                    <a href="#" className="text-white transition hover:opacity-75"> Privacy Policy </a>
                </li>

                <li>
                    <a href="#" className="text-white transition hover:opacity-75"> Cookies </a>
                </li>
                </ul>
            </div>
            </div>
        </div>

        </footer>
    )
}